/*eslint react-hooks/exhaustive-deps: "off"*/
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import MapBase from "./MapBase";
import { MapPropsProvider } from "./MapPropsContext";
import useMapProps from "./useMapProps";
import { getListByParameters } from "../../api";
import WidgetContainer from "./widgets/WidgetContainer";
import WidgetNationalParkFilter from "./widgets/WidgetNationalParkFilter";
import {
  Button,
  Drawer,
  Table,
  Tabs,
  Alert,
  Icon,
  message,
  Tooltip,
} from "antd";
import Axios from "axios";
import {
  getApiHost,
  getApiUrl,
  getLastDomByClassName,
  makeTableSorterFn,
  msgClose,
  positionToDegress,
  degressToPosition,
  makeTableSorterFnNumber,
  formatUid,
  getReadableFreq,
} from "../../utils";

import WidgetNationalParkExtraLayers from "./widgets/WidgetNationalParkExtraLayers";
import WidgetNationalPark from "./widgets/WidgetNationalPark";
import WidgetNationalParkReceiveSensitivity from "./widgets/WidgetNationalParkReceiveSensitivity";
import WidgetLegend from "./widgets/WidgetLegend";
import WidgetUidWithShortcut from "./widgets/WidgetUidWithShortcut";
import WidgetTableClicked from "./widgets/WidgetTableClicked";
import WidgetToolbar from "./widgets/WidgetToolbar";
import usePortal from "react-useportal";
import AlignRightText from "./widgets/AlignRightText";
import AlignCenterText from "./widgets/AlignCenterText";
import AlignCenterText2 from "./widgets/AlignCenterText2";
import EllipsisText from "./widgets/EllipsisText";
import usePromise from "../../utils/hooks/usePromise";
import LoadingIndicator from "../../components/LoadingIndicator";
import ExportExcelButton from "../../utils/export";
import {
  TI_LIST_CLOSE_BUTTON,
  TI_RAW_EXCEL_DOWN_BUTTON,
  TI_SHOW_LIST_BUTTON,
  TI_TABLE_EXCEL_DOWN_BUTTON,
  WELL_KNOWN_POSITION,
} from "../../Constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { StyledButton } from "../../styled-components/Button";
import StyledTableHeader from "../../styled-components/StyledTableHeader";
import { WidgetButton } from "../../styled-components/Button";


const INITIAL_VIEW_STATE = {
  ...WELL_KNOWN_POSITION.지리산,
  zoom: 12,
};

const ICON_MAPPING = {
  // SKT
  542604: {
    //    '05': ['2g-sk-out', 'SKT 2G'],
    //    '06': ['2g-sk-out', 'SKT 2G'],
    15: ["3g-sk-out", "SKT 3G"],
    18: ["4g-sk-out", "SKT 4G"],
    19: ["4g-sk-out", "SKT 4G"],
    43: ["5g-sk-out", "SKT 5G"],
    45: ["5g-sk-out", "SKT 5G"],
  },
  // KT
  542610: {
    15: ["3g-kt-out", "KT 3G"],
    18: ["4g-kt-out", "KT 4G"],
    19: ["4g-kt-out", "KT 4G"],
    43: ["5g-kt-out", "KT 5G"],
    45: ["5g-kt-out", "KT 5G"],
  },
  // LGT
  39818: {
    //    '05': ['2g-lg-out', 'LGU+ 2G'],
    //    '06': ['2g-lg-out', 'LGU+ 2G'],
    18: ["4g-lg-out", "LGU+ 4G"],
    19: ["4g-lg-out", "LGU+ 4G"],
    43: ["5g-lg-out", "LGU+ 5G"],
    45: ["5g-lg-out", "LGU+ 5G"],
  },
};

// const ICON_LEGEND = [
//   ['national-blue', `-70 ~`],
//   ['national-green', `${-70 - Math.abs(114 - 70) / 5} ~`],
//   ['national-yellow', `${-70 - Math.abs(114 - 70) / 5 * 2} ~`],
//   ['national-orange', `${-70 - Math.abs(114 - 70) / 5 * 3} ~`],
//   ['national-red', `${-70 - Math.abs(114 - 70) / 5 * 4}`],
// ];
const ICON_LEGEND = [
  ["national-blue", `매우 높음( -70 ~ ${-70 - Math.abs(114 - 70) / 5})`],
  [
    "national-green",
    `높음(${-70 - Math.abs(114 - 70) / 5} ~ ${
      -70 - (Math.abs(114 - 70) / 5) * 2
    })`,
  ],
  [
    "national-yellow",
    `보통(${-70 - (Math.abs(114 - 70) / 5) * 2} ~ ${
      -70 - (Math.abs(114 - 70) / 5) * 3
    })`,
  ],
  [
    "national-orange",
    `낮음(${-70 - (Math.abs(114 - 70) / 5) * 3} ~ ${
      -70 - (Math.abs(114 - 70) / 5) * 4
    })`,
  ],
  ["national-red", `매우 낮음(${-70 - (Math.abs(114 - 70) / 5) * 4} ~)`],
];

// const ICON_LEGEND2 = Object.values(ICON_MAPPING)
//   .map(agency => Object.values(agency))
//   .flat()
//   .filter((row1, index, self) => !self.slice(index + 1).find(row2 => (row1[0] === row2[0]) && (row1[1] === row2[1])));

const ICON_LEGEND2 = [
  /* ////1007 임창용 제거요청
  ['2g-sk-out', 'SKT 2G'],
  */
  ["3g-sk-out", "SKT 3G"],
  ["4g-sk-out", "SKT 4G"],
  ["5g-sk-out", "SKT 5G"],
  // ['2g-kt-out', 'KT 2G'],
  ["3g-kt-out", "KT 3G"],
  ["4g-kt-out", "KT 4G"],
  ["5g-kt-out", "KT 5G"],
  // ['2g-lg-out', 'LGU+ 2G'],
  // ['3g-lg-out', 'LGU+ 3G'],
  ["4g-lg-out", "LGU+ 4G"],
  ["5g-lg-out", "LGU+ 5G"],
];

message.config({
  top: 250,
  duration: 5,
  maxCount: 1,
});

const infoByExtraSearchOfBukhansan = () => {
  message.info({
    content: (
      <span style={{ fontSize: 15 }}>
        {" "}
        북한산은 "경계확장검색(3km)"을 지원하지 않습니다.
      </span>
    ),
  });
};

const MapNationalParkSignal = () => {
  const mapProps = useMapProps({
    INITIAL_POINT_LAYER_PROPS: {
      getIconCode: ({ CUS_NO, RDS_SVC_FORM_CD }) => {
        const serviceProvider = ICON_MAPPING[CUS_NO];
        if (!serviceProvider) return null;
        try {
          return serviceProvider[RDS_SVC_FORM_CD][0];
        } catch (e) {
          console.error("not found iconCode for", RDS_SVC_FORM_CD);
          return null;
        }
      },
      getIconWidth: (feature, zoom) => {
        let iconWidth = 30;

        if (zoom <= 13) {
          return 24;
        } else if (zoom >= 14) {
          return 30;
        } else {
          iconWidth -= (iconWidth * (15 - Math.max(7, zoom))) / 14;
          return Math.min(30, iconWidth);
        }
      },
      latitudeExtractorForHeatmap: ({ position }) => position[0],
      longitudeExtractorForHeatmap: ({ position }) => position[1],
      intensityExtractorForHeatmap: ({ iconCode }) =>
        ({
          "national-blue": 200,
          "national-green": 100,
          "national-yellow": 0,
          "national-orange": -100,
          "national-red": -200,
        }[iconCode]),
    },
    INITIAL_LAYER_WMS_TYPES: [
      // LAYER_WMS_TYPES.PARK_AREA_SHP,
      // LAYER_WMS_TYPES.GSTN_PMNTN_LN,
    ],
    INITIAL_WIDGET_STATE: {
      agency_name: "",
      service_code: "",
      extra_search: false,
      sensitive_3g_4g: ["3g", "4g"],
    },
    INITIAL_VIEW_STATE,
  });

  const {
    setMapCenter,
    setPointsResponseList,
    clickedPointIconObjects,
    widgetState,
    onChangeWidgetState,
    updateMapLayerNames,
    setMountainReceiveSensitivityLayerList,
    sensitivityLayerListWithband,
    setSensitivityLayerListWithband,
    setClickedPointIconObjects,
    isNationalParkHeapmap,
  } = mapProps;

  const [parkType, setParkType] = useState("국립공원");
  const [currentPark, setCurrentPark] = useState();

  const [
    mountainReceiveSensitivityTypeList,
    setMountainReceiveSensitivityTypeList,
  ] = useState(["3g", "4g"]);

  const [tableData, setTableData] = useState();
  const [isVisibleTable, setIsVisibleTable] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState();

  const { agency_name, service_code, extra_search } = widgetState;

  const [isBukhansan, setIsBukhansan] = useState(false);

  useEffect(() => {
    if (currentPark) {
      const { name } = currentPark;
      if (name === "북한산") {
        setIsBukhansan(true);
        infoByExtraSearchOfBukhansan();
      } else {
        setIsBukhansan(false);
        //message.destroy();
      }
    }
  }, [currentPark, extra_search]);

  // 산악지역 무선국 데이터의 목록보기 정렬 초기화 기능 설정
  // 컬럼 정렬 기준값을 담아둘 상탯값을 정의하고, 이를 각 컬럼의 sortOrder에 반영합니다.
  const [sortedInfo, setSortedInfo] = useState({});
  const newColumns = useMemo(() => {
    const makedColumns = [
      {
        title: "순번",
        dataIndex: "RN",
        key: "RN",
        width: 75,
        align: "center",
        // sorter: makeTableSorterFn("RN"),
        // fixed: "left",
      },
      {
        title: "허가번호",
        dataIndex: "RDS_PMS_NO",
        key: "RDS_PMS_NO",
        width: 200,
        // render: (rds_pms_no, feature) =>
        //   WidgetUidWithShortcut({
        //     feature,
        //     onClick: onClickedPointInWidgetTable,
        //   }),
        // sorter: makeTableSorterFn("RDS_PMS_NO"),
        // fixed: "left",
      },
      // {
      //   title: '호출명칭', dataIndex: 'RDS_NM', key: 'RDS_NM', width: 200
      //   , render: (RDS_NM) => <EllipsisText text={RDS_NM || "-"}/>
      //   , sorter: makeTableSorterFn('RDS_NM')
      // },
      {
        title: "시설자명",
        dataIndex: "CUS_NM",
        key: "CUS_NM",
        width: 200,
        // sorter: makeTableSorterFn("CUS_NM"),
      },
      {
        title: "설(상)치장소",
        dataIndex: "RDS_TRS_ADR",
        key: "RDS_TRS_ADR",
        width: 170,
        render: (RDS_TRS_ADR) => (
          <WidgetButton>
            <EllipsisText text={RDS_TRS_ADR} />
          </WidgetButton>
        ),
        // sorter: makeTableSorterFn("RDS_TRS_ADR"),
      },
      {
        title: "용도",
        dataIndex: "RDS_SVC_FORM_NM",
        key: "RDS_SVC_FORM_NM",
        width: 400,
        sorter: makeTableSorterFn("RDS_SVC_FORM_NM"),
      },
      {
        title: "장치개수",
        dataIndex: "RDS_EQM_SNU",
        key: "RDS_EQM_SNU",
        width: 100,
        render: (text) => AlignRightText({ text }),
        // sorter: makeTableSorterFn("RDS_EQM_SNU"),
      },
      {
        title: "경도",
        dataIndex: "LAT",
        key: "LAT",
        width: 150,
        render: (text) => AlignCenterText({ text }),
      },
      {
        title: "위도",
        dataIndex: "LON",
        key: "LON",
        width: 150,
        render: (text) => AlignCenterText({ text }),
      },
      {
        title: "주파수(MHz)",
        dataIndex: "FRQ_HZ",
        key: "FRQ_HZ",
        width: 100,
        render: (frq_hz) =>
          frq_hz &&
          frq_hz
            .toString()
            .split(",")
            .map((frq) => {
              return AlignCenterText({
                children: (
                  <Tooltip title={frq} placement={"top"}>
                    {frq}
                  </Tooltip>
                ),
              });
            }),
        // sorter: makeTableSorterFn("FRQ_HZ"),
      },
      {
        title: "출력(W)",
        dataIndex: "ARW_PWR_WTT",
        key: "ARW_PWR_WTT",
        width: 100,
        render: (text) => AlignRightText({ text }),
        // sorter: makeTableSorterFn("ARW_PWR_WTT"),
      },
      {
        title: "안테나설치형태",
        dataIndex: "ARW_WEK_NSN_FORM_CD_NM",
        key: "ARW_WEK_NSN_FORM_CD_NM",
        width: 160,
        // sorter: makeTableSorterFn("ARW_WEK_NSN_FORM_CD_NM"),
      },
      {
        title: "대표이득",
        dataIndex: "ARW_GAN_NMV",
        key: "ARW_GAN_NMV",
        width: 100,
        render: (text) => AlignRightText({ text }),
        // sorter: makeTableSorterFn("ARW_GAN_NMV"),
      },
      {
        title: "해발고",
        dataIndex: "ARW_ALT_ALTD_HET",
        key: "ARW_ALT_ALTD_HET",
        width: 100,
        render: (text) => AlignRightText({ text }),
        // sorter: makeTableSorterFn("ARW_ALT_ALTD_HET"),
      },
      {
        title: "지상고",
        dataIndex: "ARW_GND_ALTD_HET",
        key: "ARW_GND_ALTD_HET",
        width: 100,
        render: (text) => AlignRightText({ text }),
        // sorter: makeTableSorterFn("ARW_GND_ALTD_HET"),
      },
      {
        title: "노출고",
        dataIndex: "ARW_EXPS_ALTD_HET",
        key: "ARW_EXPS_ALTD_HET",
        width: 100,
        render: (text) => AlignRightText({ text }),
        // sorter: makeTableSorterFn("ARW_EXPS_ALTD_HET"),
      },
      //{
      //  title: '공중선주설치형태', dataIndex: 'ARW_WEK_NSN_FORM_CD_NM', key: 'ARW_WEK_NSN_FORM_CD_NM', width: 150,
      //  render: text => AlignRightText({text}),
      //  sorter: makeTableSorterFn('ARW_WEK_NSN_FORM_CD_NM')
      //},
    ];
    return makedColumns.map((column) => {
      const { dataIndex } = column;
      const { columnKey, order } = sortedInfo || {};
      const sortOrder = columnKey === dataIndex && order;
      return {
        ...column,
        sortOrder,
      };
    });
  }, [sortedInfo]);

  // 수신 감도 목록보기 정렬 초기화 기능 설정
  // 컬럼 정렬 기준값을 담아둘 상탯값을 정의하고, 이를 각 컬럼의 sortOrder에 반영합니다.
  const newColumnsBySensitiveData = useMemo(() => {
    if (sensitivityLayerListWithband) {
      const makedColumns = [
        {
          title: "순번",
          dataIndex: "rownum",
          key: "rownum",
          width: 75,
          align: "center",
          sorter: makeTableSorterFn("rownum"),
        },
        {
          title: "수신감도",
          dataIndex: "value",
          key: "value",
          render: (text) => AlignRightText({ text }),
          sorter: makeTableSorterFnNumber("value"),
        },
        {
          title: "사업자",
          dataIndex: "agency",
          key: "agency",
          render: (text) => AlignCenterText({ text }),
          sorter: makeTableSorterFn("agency"),
        },
        {
          title: "위도",
          dataIndex: "lon",
          key: "lon",
          render: (text) => AlignRightText({ text }),
        },
        {
          title: "경도",
          dataIndex: "lat",
          key: "lat",
          render: (text) => AlignRightText({ text }),
        },
        {
          title: "서비스 종류",
          dataIndex: "type",
          key: "type",
          render: (text) => AlignCenterText({ text }),
          sorter: makeTableSorterFn("type"),
        },
        {
          title: "밴드",
          dataIndex: "band",
          key: "band",
          render: (text) => AlignCenterText({ text }),
          sorter: makeTableSorterFnNumber("band"),
        },
        {
          title: "주파수(Mhz)",
          dataIndex: "frq_hz",
          key: "frq_hz",
          render: (text) => AlignCenterText({ text }),
          sorter: makeTableSorterFnNumber("frq_hz"),
        },
        {
          title: "대역폭(Mhz)",
          dataIndex: "band_width",
          key: "band_width",
          render: (text) => AlignCenterText({ text }),
          sorter: makeTableSorterFnNumber("band_width"),
        },
      ];
      return makedColumns.map((column) => {
        const { dataIndex } = column;
        const { columnKey, order } = sortedInfo || {};
        const sortOrder = columnKey === dataIndex && order;
        return {
          ...column,
          sortOrder,
        };
      });
    }
  }, [sortedInfo, sensitivityLayerListWithband]);

  // 테이블의 변경정보를 관련 상탯값에 반영합니다.
  const onChangeTable = useCallback((pagination, filters, sorter) => {
    setSortedInfo(sorter);
  }, []);

  useEffect(() => {
    updateMapLayerNames("PARK_AREA_SHP", true);
  }, []);

  // 공원목록에서 공원이 선택되면, 해당 위치로 지도를 이동시키고
  // 해당 공원의 무선국 목록을 읽어들여 지도에 표시합니다. - FIXME: 쿼리 응답이 느려서 페이징 처리가 필요합니다.
  const [stationListLoading, stationListResponse] = usePromise(() => {
    if (currentPark) {
      onChangeWidgetState({ target: { name: "extra_search", value: false } });
      const { name, rx, ry, lx, ly } = currentPark;

      // FIXME: viewport.fitBounds를 통해 적정 latitude/longitude/zoom 찾기
      // https://github.com/uber/deck.gl/blob/master/docs/developer-guide/views.md#viewport
      // viewport.fitBounds([...])

      const latitude = (parseFloat(ly) + parseFloat(ry)) / 2;
      const longitude = (parseFloat(lx) + parseFloat(rx)) / 2;
      const zoom = 12;

      // 폴리곤과 아이콘이 잘 보이도록 center 위치 조정
      if (name && name === "다도해해상") {
        const latitude = 34.22528708016888;
        const longitude = 126.70858383178712;
        const zoom = 12;
        setMapCenter({ latitude, longitude, zoom });
      } else if (name && name === "한려해상") {
        const latitude = 34.76573012897112;
        const longitude = 128.55205535888675;
        const zoom = 12;
        setMapCenter({ latitude, longitude, zoom });
      } else if (name && name === "신안증도갯벌") {
        const latitude = 34.9812056936735;
        const longitude = 126.11309051513673;
        const zoom = 12;
        setMapCenter({ latitude, longitude, zoom });
      } else {
        setMapCenter({ latitude, longitude, zoom });
      }

      // 국립공원 `name`의 무선국 정보를 획득합니다.
      const pointsUrl = getApiHost() + "/gis/nationalparkServiceListArw.json";
      const formData = new FormData();
      const encodeName = encodeURI(name);
      formData.append("innpk_nm", encodeName);
      if (extra_search && name !== "북한산") {
        formData.append("extra", "Y");
      } else {
        formData.append("extra", "N");
      }

      return Axios.post(pointsUrl, formData);
    }
  }, [currentPark, extra_search]);

  useEffect(() => {
    if (extra_search && !stationListLoading) {
      msgClose();
    }
  }, [stationListLoading]);

  useEffect(() => {
    if (stationListResponse) {
      const { data } = stationListResponse;
      const serviceCodeList =
        service_code.length === 0 ? [] : service_code.split(",");
      setPointsResponseList([
        data
          .filter(({ CUS_NO }) => {
            return agency_name.length === 0 || CUS_NO === agency_name;
          })
          .filter(({ RDS_SVC_FORM_CD }) => {
            return (
              serviceCodeList.length === 0 ||
              serviceCodeList.includes(RDS_SVC_FORM_CD)
            );
          })
          .map((item) => {
            return {
              uid: item.RDS_PMS_NO,
              position: [
                parseFloat(item.RDS_TRS_ADR_LOU_CDN),
                parseFloat(item.RDS_TRS_ADR_LTD_CDN),
              ],
              ...item,
            };
          }),
      ]);
    }
  }, [stationListResponse, agency_name, service_code, setPointsResponseList]);
{/* 20220721 주석
  useEffect(() => {
    if (!currentPark || mountainReceiveSensitivityTypeList.length === 0) {
      setMountainReceiveSensitivityLayerList([]);
      setSensitivityLayerListWithband([]);
    } else {
      const { name } = currentPark;

      (async function () {
        setMountainReceiveSensitivityLayerList([]);
        setSensitivityLayerListWithband([]);
        const sensitivityUrl = getApiUrl({ type: "type4", parkNm: name });

        const result = await Axios.get(sensitivityUrl);
        const urlList = [result.data.data, result.data.points];
        const responseList = await Axios.all(
          urlList.map((url) => Axios.get(getApiHost() + url))
        );
        const layerList = responseList.map(({ data }) => data);

        // 수신감도 목록보기용 데이터 가공
        setSensitivityLayerListWithband(
          [layerList[0]].map((bandList) => {
            return bandList
              .filter(({ type }) => {
                return mountainReceiveSensitivityTypeList.includes(type);
              })
              .filter(({ agency }) => {
                if (agency_name === 542604) {
                  return "SKT" === agency;
                } else if (agency_name === 542610) {
                  return "KT" === agency;
                } else if (agency_name === 39818) {
                  return "LGT" === agency;
                } else {
                  return true;
                }
              })
              .filter(({ value }) => value !== 0)
              .map((banditem, i) => {
                const [longitude, latitude] = banditem.position;
                const agency = banditem.agency;
                const band = banditem.band;
                const index = banditem.index;
                const type = banditem.type.toUpperCase();
                const uid = banditem.uid;
                const value = banditem.value;
                const rownum = i + 1;
                const lon = degressToPosition(longitude);
                const lat = degressToPosition(latitude);
                const tableResult = NationalHzTable.find(
                  ({ agency, type, band }) =>
                    agency === banditem.agency &&
                    type === banditem.type.toUpperCase() &&
                    band === banditem.band
                      ? true
                      : false
                );
                let let_frq_hz = 0;
                let let_band_width = 0;
                if (tableResult !== undefined) {
                  const { frq_hz, band_width } = tableResult;
                  let_frq_hz = frq_hz;
                  let_band_width = band_width;
                }

                return {
                  agency,
                  band,
                  index,
                  type,
                  uid,
                  value,
                  lon,
                  lat,
                  rownum,
                  frq_hz: let_frq_hz,
                  band_width: let_band_width,
                };
              });
          })[0]
        );
        // 수신감도 아이콘 지도 위에 뿌리기 위해 가공
        setMountainReceiveSensitivityLayerList(
          [layerList[1]].map((propertiesList) => {
            return propertiesList
              .filter(({ type }) => {
                return mountainReceiveSensitivityTypeList.includes(type);
              })
              .filter(({ agency }) => {
                if (agency_name === 542604) {
                  return "SKT" === agency;
                } else if (agency_name === 542610) {
                  return "KT" === agency;
                } else if (agency_name === 39818) {
                  return "LGT" === agency;
                } else {
                  return true;
                }
              })
              .map((properties) => {
                const { agency, position, type } = properties;
                const [longitude, latitude] = position;

                let value = Math.abs(properties.value);
                const range = [Math.abs(-70), Math.abs(-114)];
                const iconCodeList = [
                  "national-blue",
                  "national-green",
                  "national-yellow",
                  "national-orange",
                  "national-red",
                ];
                const step =
                  Math.abs(range[0] - range[1]) / iconCodeList.length;
                if (value < range[0]) value = range[0];
                if (value > range[1]) value = range[1];

                const index = Math.floor((Math.abs(value) - range[0]) / step);
                const iconCode =
                  index >= 5 ? iconCodeList[4] : iconCodeList[index];

                const popupMessage = (
                  <>
                    <div
                      style={{
                        color: "#186fc1",
                        fontWeight: "bold",
                        fontSize: "14px",
                      }}
                    >
                      {agency} ({type.toUpperCase()})
                    </div>
                    {-value}
                  </>
                );

                return {
                  position: [latitude, longitude],
                  iconCode,
                  popupMessage,
                };
              });
          })
        );
      })();
    }
  }, [currentPark, mountainReceiveSensitivityTypeList, agency_name]);
*/}
  useEffect(() => {
    if (isVisibleTable && currentPark) {
      const { name } = currentPark;
      updateTable({ name, setTableData, setIsLoading, setError, extra_search });
    } else {
      setTableData(null);
      setError(null);
      setSortedInfo(null);
    }
  }, [isVisibleTable]);

  const onClickedPointInWidgetTable = useCallback(
    (feature) => {
      const { latitude, longitude } = feature;
      const newLongitude = positionToDegress(longitude);
      const newLatitude = positionToDegress(latitude);
      const newFeature = { ...feature, position: [newLongitude, newLatitude] };
      setClickedPointIconObjects([newFeature]);

      setTimeout(() => {
        if (modalCloseButtonRef.current) {
          modalCloseButtonRef.current.focus();
        }
      }, 300);
    },
    [setClickedPointIconObjects]
  );

  useEffect(() => {
    // 딜레이를 주어, 보다 자연스럽게 Drawer창을 끕니다.
    setTimeout(() => {
      setIsVisibleTable(false);
    }, 200);
  }, [clickedPointIconObjects]);

  const { Portal } = usePortal({
    bindTo: getLastDomByClassName("toolbar-show-list"),
  });

  const [isDownloading, setIsDownloading] = useState(false);
  const [isSensitiveDownloading, setSensitiveIsDownloading] = useState(false);

  const downloadXlsx = useCallback(() => {
    setError(null);
    setIsDownloading(true);
    const { name } = currentPark;
    const params = {
      isExcelDownload: true,
      innpk_nm: name,
      extraYn: extra_search ? "Y" : "N",
    };
    getListByParameters(params)
      .then(({ data }) => {
        setIsDownloading(false);
      })
      .catch((e) => setError(e));
  }, [currentPark, extra_search]);

  const downloadXSensitivelsx = useCallback(() => {
    if (sensitivityLayerListWithband) {
      setError(null);
      setSensitiveIsDownloading(false);
    }
  }, [sensitivityLayerListWithband]);

  const [listTabName, setListTabName] = useState("wifi");

  const closeButtonRef = useRef(null);
  const modalCloseButtonRef = useRef(null);
  const showListButtonRef = useRef(null);

  return (
    <MapPropsProvider value={mapProps}>
      <MapBase>
        <WidgetContainer>
          <div>
            <WidgetNationalPark
              parkType={parkType}
              setParkType={setParkType}
              defaultParkDict={{
                국립공원: "지리산",
                도립공원: "팔공산",
                군립공원: "강천산",
              }}
              setCurrentPark={setCurrentPark}
            />
            <WidgetNationalParkFilter
              disabled={!currentPark}
              isBukhansan={isBukhansan}
              currentPark={currentPark}
            />
            {/* 20220721 주석
            <WidgetNationalParkReceiveSensitivity
              currentPark={currentPark}
              mountainReceiveSensitivityTypeList={
                mountainReceiveSensitivityTypeList
              }
              setMountainReceiveSensitivityTypeList={
                setMountainReceiveSensitivityTypeList
              }
            />*/}

            <WidgetNationalParkExtraLayers currentPark={currentPark} />
          </div>
        </WidgetContainer>

        <WidgetTableClicked
          closeButtonRef={modalCloseButtonRef}
          getTitle={(objects) =>
            `${objects.length}개의 산악지역 무선기지국 정보`
          }
          objects={clickedPointIconObjects}
          getRow={({
            RDS_PMS_NO,
            RDS_NM,
            CUS_NM,
            RDS_TRS_ADR,
            RDS_SVC_FORM_NM,
            RDS_TRS_ADR_LOU_CDN,
            RDS_TRS_ADR_LTD_CDN,
            ARW_ALT_ALTD_HET,
            ARW_GND_ALTD_HET,
            ARW_EXPS_ALTD_HET,
            ARW_WEK_NSN_FORM_CD_NM,
          }) => (
            <table>
              <tbody>
                <tr>
                  <th>허가번호</th>
                  <td>{formatUid(RDS_PMS_NO)}</td>
                </tr>
                <tr>
                  <th>호출 명칭/부호</th>
                  <td>{RDS_NM}</td>
                </tr>
                <tr>
                  <th>시설자명</th>
                  <td>{CUS_NM}</td>
                </tr>
                <tr>
                  <th>설(상)치 장소</th>
                  <td>{RDS_TRS_ADR}</td>
                </tr>
                <tr>
                  <th>이동통신서비스</th>
                  <td>{RDS_SVC_FORM_NM}</td>
                </tr>
                <tr>
                  <th>경도</th>
                  <td>{`${degressToPosition(
                    RDS_TRS_ADR_LOU_CDN
                  )}(${RDS_TRS_ADR_LOU_CDN})`}</td>
                </tr>
                <tr>
                  <th>위도</th>
                  <td>{`${degressToPosition(
                    RDS_TRS_ADR_LTD_CDN
                  )}(${RDS_TRS_ADR_LTD_CDN})`}</td>
                </tr>
                <tr>
                  <th>해발고</th>
                  <td>{ARW_ALT_ALTD_HET}</td>
                </tr>
                <tr>
                  <th>지상고</th>
                  <td>{ARW_GND_ALTD_HET}</td>
                </tr>
                <tr>
                  <th>노출고</th>
                  <td>{ARW_EXPS_ALTD_HET}</td>
                </tr>
                <tr>
                  <th>공중선주형태</th>
                  <td>{ARW_WEK_NSN_FORM_CD_NM}</td>
                </tr>
              </tbody>
            </table>
          )}
        />
        <>
          <Portal>
            <StyledButton
              tabIndex={TI_SHOW_LIST_BUTTON}
              isActive={isVisibleTable}
              // type={isVisibleTable ? "primary" : undefined}
              disabled={!currentPark}
              onClick={() => setIsVisibleTable((visible) => !visible)}
              ref={showListButtonRef}
            >
              목록 보기
            </StyledButton>
          </Portal>

          <Drawer
            placement={"bottom"}
            height={300 + 180}
            visible={isVisibleTable}
            closable={false}
            bodyStyle={{ padding: 12 }}
          >
            <div style={{ height: "100%" }}>
              <StyledTableHeader>
                <div>
                  <StyledButton
                    style={{ borderRadius: "4px 0px 0px 4px" }}
                    isActive={listTabName === "wifi"}
                    onClick={() => setListTabName("wifi")}
                    // tabIndex={TI_LIST_CLOSE_BUTTON - 3}
                  >
                    {tableData && Object.values(tableData).length > 0
                      ? `총 무선국수 ${tableData[0] && tableData[0].TOT_NUM}건`
                      : "총 무선국 수 0건"}
                  </StyledButton>
                  <StyledButton
                    style={{ borderRadius: "0px 4px 4px 0px" }}
                    isActive={listTabName === "signal"}
                    onClick={() => setListTabName("signal")}
                    // tabIndex={TI_LIST_CLOSE_BUTTON - 2}
                  >
                    {sensitivityLayerListWithband &&
                    Object.values(sensitivityLayerListWithband).length > 0
                      ? `총 수신감도 수 ${sensitivityLayerListWithband.length}건`
                      : "총 수신감도 수 0건"}
                  </StyledButton>
                </div>
                <div>
                  {listTabName === "wifi" && (
                    <StyledButton
                      onClick={downloadXlsx}
                      style={{ marginRight: 8 }}
                      isActive
                      // tabIndex={TI_LIST_CLOSE_BUTTON - 1}
                    >
                      {isDownloading && <Icon type="loading" />}
                      {!isDownloading && <FontAwesomeIcon icon={faFileExcel} />}
                      <span style={{ marginLeft: 8 }}>엑셀 내보내기</span>
                    </StyledButton>
                  )}
                  {listTabName === "signal" && (
                    <ExportExcelButton
                      onClick={downloadXSensitivelsx}
                      style={{ marginRight: 8 }}
                      type="primary"
                      disabled={isSensitiveDownloading}
                      filename={"산악지역 이동통신 찾기_수신감도.xls"}
                      data={sensitivityLayerListWithband}
                      // tabIndex={TI_LIST_CLOSE_BUTTON - 1}
                      columns={[
                        {
                          title: "순번",
                          dataIndex: "rownum",
                          key: "rownum",
                          width: 75,
                          align: "center",
                          sorter: makeTableSorterFn("rownum"),
                        },
                        {
                          title: "수신감도",
                          dataIndex: "value",
                          key: "value",
                          render: (text) => AlignRightText({ text }),
                          sorter: makeTableSorterFn("value"),
                        },
                        {
                          title: "사업자",
                          dataIndex: "agency",
                          key: "agency",
                          render: (text) => AlignCenterText({ text }),
                          sorter: makeTableSorterFn("agency"),
                        },
                        {
                          title: "위도",
                          dataIndex: "lon",
                          key: "lon",
                          render: (text) => AlignRightText({ text }),
                        },
                        {
                          title: "경도",
                          dataIndex: "lat",
                          key: "lat",
                          render: (text) => AlignRightText({ text }),
                        },
                        {
                          title: "서비스 종류",
                          dataIndex: "type",
                          key: "type",
                          render: (text) => AlignCenterText({ text }),
                          sorter: makeTableSorterFn("type"),
                        },
                        {
                          title: "밴드",
                          dataIndex: "band",
                          key: "band",
                          render: (text) => AlignCenterText({ text }),
                          sorter: makeTableSorterFnNumber("band"),
                        },
                        {
                          title: "주파수(Mhz)",
                          dataIndex: "frq_hz",
                          key: "frq_hz",
                          render: (text) => AlignCenterText({ text }),
                          sorter: makeTableSorterFnNumber("frq_hz"),
                        },
                        {
                          title: "대역폭(Mhz)",
                          dataIndex: "band_width",
                          key: "band_width",
                          render: (text) => AlignCenterText({ text }),
                          sorter: makeTableSorterFnNumber("band_width"),
                        },
                      ]}
                    >
                      {isSensitiveDownloading && <Icon type="loading" />}
                      {!isSensitiveDownloading && (
                        <FontAwesomeIcon icon={faFileExcel} />
                      )}
                      <span style={{ marginLeft: 8 }}>엑셀 내보내기</span>
                    </ExportExcelButton>
                  )}
                  <StyledButton
                    // tabIndex={TI_LIST_CLOSE_BUTTON}
                    onClick={() => {
                      setIsVisibleTable(false);
                      setTimeout(() => {
                        if (showListButtonRef.current) {
                          showListButtonRef.current.focus();
                        }
                      }, 300);
                    }}
                    ref={closeButtonRef}
                  >
                    닫기
                  </StyledButton>
                </div>
              </StyledTableHeader>
              {error && (
                <Alert
                  message={
                    "데이터 로딩에 실패했습니다. 잠시 후 다시 시도해주세요."
                  }
                  type={"error"}
                />
              )}

              {!error && listTabName === "wifi" && (
                <Table
                  dataSource={tableData}
                  // columns={makeColums()}
                  columns={newColumns}
                  onChange={onChangeTable}
                  size={"small"}
                  rowKey={"RN"}
                  bordered={true}
                  loading={!tableData && !error}
                  ellipsis={true}
                  // scroll={{ x: 2150, y: 300 }}
                  pagination={{
                    defaultPageSize: 20,
                    showSizeChanger: true,
                    pageSizeOptions: ["20", "50", "100"],
                  }}
                />
              )}

              {!error && listTabName === "signal" && (
                <Table
                  dataSource={sensitivityLayerListWithband}
                  columns={newColumnsBySensitiveData}
                  onChange={onChangeTable}
                  size={"small"}
                  rowKey={"uid"}
                  bordered={true}
                  loading={!sensitivityLayerListWithband && !error}
                  ellipsis={true}
                  // scroll={{ x: 1900, y: 300 }}
                  pagination={{
                    defaultPageSize: 20,
                    showSizeChanger: true,
                    pageSizeOptions: ["20", "50", "100"],
                  }}
                />
              )}
            </div>
          </Drawer>
        </>
{/* 20220721 수정
//        {!isNationalParkHeapmap ? (
*/}
        {isNationalParkHeapmap ? (
          <WidgetLegend iconLegend={ICON_LEGEND} iconLegend2={ICON_LEGEND2} />
        ) : (
          <WidgetLegend iconLegend={ICON_LEGEND2} />
        )}
      </MapBase>
      <WidgetToolbar />

      <LoadingIndicator visible={stationListLoading || !stationListResponse} />
    </MapPropsProvider>
  );
};

const updateTable = ({
  name,
  setTableData,
  setIsLoading,
  setError,
  extra_search,
}) => {
  setIsLoading(true);
  const url = getApiHost() + "/gis/nationalparkServiceListArw.json";
  const formData = new FormData();
  const encodeName = encodeURI(name);

  formData.append("innpk_nm", encodeName);
  if (extra_search) {
    formData.append("extra", "Y");
  } else {
    formData.append("extra", "N");
  }
  Axios.post(url, formData)
    .then((response) => {
      const { data } = response;
      setTableData(data);
      setIsLoading(false);
    })
    .catch((e) => {
      setError(e);
    });
};

const STYLE_SUBMIT = {
  position: "absolute",
  top: 4,
  right: 0,
};

const NationalHzTable = [
  { band: "1", agency: "SKT", type: "3G", frq_hz: 2137.5, band_width: 15 },
  { band: "1", agency: "KT", type: "4G", frq_hz: 2115, band_width: 10 },
  { band: "1", agency: "LGT", type: "4G", frq_hz: 2120, band_width: 20 },
  { band: "2.1", agency: "SKT", type: "3G", frq_hz: 2147.4, band_width: 5 },
  { band: "2.1", agency: "KT", type: "3G", frq_hz: 2167.2, band_width: 5 },
  { band: "3", agency: "SKT", type: "4G", frq_hz: 1820, band_width: 20 },
  { band: "3", agency: "KT", type: "4G", frq_hz: 1840, band_width: 20 },
  { band: "5", agency: "SKT", type: "4G", frq_hz: 879, band_width: 10 },
  { band: "5", agency: "LGT", type: "4G", frq_hz: 889, band_width: 10 },
  { band: "7", agency: "SKT", type: "4G", frq_hz: 2630, band_width: 20 },
  { band: "7", agency: "LGT", type: "4G", frq_hz: 2650, band_width: 20 },
  { band: "8", agency: "KT", type: "4G", frq_hz: 954.3, band_width: 20 },
];

export default MapNationalParkSignal;
